<template>
    <div
        class="md-property-history broker"
        v-if="historys && historys.length > 0"
    >
        <module-box
            :fullColumn="fullColumn"
            :btmSpacing="btmSpacing"
            :topSpacing="topSpacing"
            :mobileNoMargin="true"
            :mobileTopSpacing="mobileTopSpacing"
            :mobileBtmSpacing="mobileBtmSpacing"
        >
            <div class="mg-title" v-html="formatFontSize(title, '--mg-title-size')"></div>
            <div class="content-container">
                <div class="list-property-history">
                    <div class="list-header">
                        <span>{{ $t('md-property-history.date') }}</span>
                        <span>{{ $t('md-property-history.event') }}</span>
                        <span>{{ $t('md-property-history.price') }}</span>
                    </div>
                    <div class="list-sub-header">
                        {{ $t('md-property-history.today') }}
                    </div>
                    <ul class="list-box">
                        <li
                            v-for="(item, index) in historys"
                            :key="index"
                            v-show="index < 5 || (index >= 5 && opened)"
                        >
                            <div class="property-date-source">
                                <only-client>
                                    <span class="property-date">{{
                                        $ft.formatDate(item.date, 'MM/dd/yyyy')
                                    }}</span>
                                </only-client>
                                <span class="property-source" :title="source">{{
                                    $t('md-property-history.source', { source,interpolation: { escapeValue: false }  })
                                }}</span>
                            </div>
                            <div class="property-status-wrap">
                                <span class="property-status">{{
                                    $t(`common:${item.event}`)
                                }}</span>
                            </div>
                            <div class="property-price">
                                <span class="price">{{ item.showPrice }}</span>
                                <span
                                    :class="{
                                        'trend-up': item.diff > 0,
                                        'trend-down': item.diff < 0
                                    }"
                                    v-if="item.diff"
                                >
                                    <i class="iconfont icon-angle" />
                                    {{ item.diff > 0 ? '+' : ''
                                    }}{{ item.diff }}%
                                </span>
                            </div>
                        </li>
                    </ul>
                    <div class="list-sub-header" v-show="showPrevRecord">
                        {{ $t('md-property-history.previousRecord') }}
                    </div>
                </div>
            </div>
            <div
                class="history-more"
                :class="{ opened: opened }"
                v-if="historys.length > 5"
                @click="toggle"
            >
                {{
                    opened
                        ? $t('md-property-history.showLess')
                        : $t('md-property-history.showMore')
                }}
                <span class="iconfont icon-arrow_04_down"></span>
            </div>
        </module-box>
    </div>
</template>

<script>
import Common from '../index.js';
export default {
    mixins: [Common]
};
</script>
<style lang="scss">
@import '../../../theme/mixin.scss';
.md-property-history.broker {
    --property-history-border-color: #f1f2f3;
    --property-history-weak-cue-color: #505050;
    --property-history-second-color: #515666;
    --property-history-first-color: #191919;
    .mg-title {
        font: 24px var(--font-bold);
        padding-bottom: 20px;
        @include media-600 {
            font: 16px var(--font-bold);
        }
    }
    .list-property-history .list-sub-header {
        background-color: #f7f7f7;
    }
    .list-property-history .list-box li {
        border-bottom-width: 2px;
    }
    .history-more {
        margin-top: 20px;
        padding: 6px 0;
        font: 14px var(--font-normal);
        color: var(--color-theme);
        line-height: 18px;
        border-radius: 4px;
        background-color: rgba(0, 0, 0, 0.03);
    }
    .history-more .iconfont {
        margin-left: 5px;
    }
    .list-property-history .list-box li .property-price .trend-up .iconfont,
    .list-property-history .list-box li .property-price .trend-down .iconfont {
        transform: scale(1, 1.9);
    }
    .list-property-history .list-box li .property-price .price {
        margin-right: 20px;
    }
    .list-property-history .list-box li:last-child {
        border-bottom: 2px solid var(--property-history-border-color);
    }
    .list-property-history .list-box li .property-source {
        margin-top: 8px;
    }
    @include media-600 {
        .list-box {
            padding: 0 15px;
            li {
                padding: 0;
            }
        }
        .history-more {
            width: calc(100% - 30px);
            margin-left: 15px;
        }
    }
}
@import '../index.scss';
</style>
